export default {
  label: {
    placeholder: {
      dashboardSelect: 'Selecione um dashboard',
    },
    title: {
      welcomeMessage: 'Olá',
      infoMessage: 'Vamos nos conhecer um pouco mais para personalizar a sua experiência!',
      firstStepMessage: 'Pra começar, conte pra nós um pouco sobre você.',
      dashboardSelectionMessage: 'Aqui você encontra os seus dashboards.',
      noTitleDasboard: 'Dashboard sem titulo',
      requiredMessage: '* Os campos abaixo são obrigatórios.',
      department: 'Departamento',
      job: 'Cargo',
      selectDashboard: 'Dashboards',
      newDepartment: 'Departamento novo',
      newJob: 'Cargo novo',
      others: 'Outros',
      finishMessage: 'É isso! Agora você tem tudo para fazer história.',
      haveFunMessage: 'E não esqueça de se divertir também ;)',
      useCaseMessage: 'Que tipo de uso você faz dos produtos da Stilingue?',
      mustChooseUseCaseMessage: 'Você precisa escolher, pelo menos, um caso de uso para seguir no onboarding.',
      notFoundUseCaseMessage: 'Caso você não tenha encontrado acima.',
      writeHereMessage: 'Escreva aqui',
      dashboardModelsMessage: 'Legal! Estes são os modelos de dashbords pra você.',
      emptyDashboardMessage: 'Você também pode começar com um dashboard em branco, se preferir.',
      indicatedForMessage: 'Indicado para',
      chooseDashboardNameMessage: 'Como gostaria de chamar seu dashboard?',
      chooseDashboardNameLaterMessage: 'Você pode fazer isso depois, se preferir.',
      exploreMessage: 'Explorar',
      closeMessage: 'Fechar Visualização',
    },
    button: {
      startFormButton: 'Vamos lá',
      nextButton: 'Próximo',
      previousButton: 'Anterior',
      lastButtonLabel: 'Fazer história com o Studio',
    },
  },
  identifier: {
    step: {
      userAndCompany: 'Usuário e empresa',
      stiUseCases: 'Casos de uso STI',
      dashboardsTemplates: 'Modelos de dashboards',
      dashboardName: 'Nome do dashboard',
      dashboardSelection: 'Escolha de dashboard',
    },
  },
};
